import type { Leg } from 'types/Leg.ts';
import { useBatchResourcePermissions } from '#admin/hook/useBatchResourcePermissions.tsx';

type LegPermissionOperations = 'LegAssignSupplier' | 'LegAssignDriver' | 'LegUpdate';

export const useLegPermissions = (legs: Leg[], operations: LegPermissionOperations[] = ['LegAssignSupplier', 'LegAssignDriver']) => {
  const resources = legs.map((leg) => ({ resourceId: leg.id, operations }));

  const { getPermission, isLoading, error } = useBatchResourcePermissions(resources);

  const getLegPermission = (legId: string, operation: LegPermissionOperations): boolean | undefined => getPermission(legId, operation);

  const canUpdateLeg = (leg: Leg): boolean | undefined => getLegPermission(leg.id, 'LegUpdate');

  const canAssignSupplier = (leg: Leg): boolean | undefined => getLegPermission(leg.id, 'LegAssignSupplier');

  const canAssignDriver = (leg: Leg): boolean | undefined => getLegPermission(leg.id, 'LegAssignDriver');

  return { getLegPermission, canUpdateLeg, canAssignSupplier, canAssignDriver, isLoading, error };
};
